import React, { useState, useEffect } from "react";
import Select from "react-select";
import DeleteModal from "../Helpers/Modal/DeleteModal";


const InvoiceLineItem = ({ lineItem, updateLineItem, handleDelete, donations, invoice, connections }) => {
  const [deleting, setDeleting] = useState(false);
  const [openModal, setOpenModal] = useState(true);
  const [items, setItems] = useState(donations)
  const [receivers, setReceivers] = useState(connections)
  const [receiver, setReceiver] = useState(null)
  const [updated, setUpdated] = useState(false)

  const prepData = (value) => {
    let data;
    receivers.map(beneficiary => {
      if (beneficiary.name == value.name) {
        data = beneficiary
        return
      }
    })

    let formattedData = {
      id: data.id,
      name: data.name
    }

    if (data.user_type) {
      formattedData.type = data.user_type
    } else {
      formattedData.type = "project"
    }

    updateLineItem(lineItem, { beneficiary: formattedData})
  }

  let donation;

  useEffect(() => {
      let keeper = connections.map(connection => {
        if (connection.user_type == lineItem.beneficiary.type && connection.id == lineItem.beneficiary.id) {
          return connection
        }

        if (!connection.user_type && lineItem.beneficiary.type == "project" && connection.id == lineItem.beneficiary.id) {
          return connection
        }
      })
      setReceiver(keeper)
    setUpdated(false)
  }, [updated == true])

  if (!lineItem.donation_id) {
    let holder = items.filter(item => !item.archived)
    donation = holder[0];
    lineItem.donation_id = holder[0].id
  } else {
    donation = donations.find(element => element.id == lineItem.donation_id);
  }

  useEffect(() => {
    // remove archived donation items
    let holder = items.filter(donation => !donation.archived)
    setItems(holder)
  }, [])

  const totalDonation = +donation.unit_cost * +lineItem.quantity;
  const totalTax = +lineItem.tax;
  const totalLineItem = totalDonation + totalTax;

  return (
    <React.Fragment>

        <div className="row line-items-row">
          <div className="col-md-4" style={{ padding: "0px" }}>
            {(invoice.status == "active" || invoice.status == "overdue" || invoice.status == "sent" || invoice.status == "paid") &&
              <div className="form-group">
                <label>Donation</label>
                <Select
                  className="form-control"
                  classNamePrefix="select-donation"
                  value={donation}
                  onChange={(value) => {
                    updateLineItem(lineItem, { donation_id: value.id })
                  }}
                  isDisabled
                  options={items}
                  getOptionLabel={(donation) => `${donation.name} | ${donation.description} | ${parseFloat(donation.unit_cost).toFixed(2)} ${donation.currency}`}
                  getOptionValue={(donation) => donation.id}
                />
              </div>
            }
            {(!invoice.status || invoice.status === "draft") &&
              <div className="form-group">
                <label>Donation</label>
                <Select
                  className="form-control"
                  classNamePrefix="select-donation"
                  value={donation}
                  onChange={(value) => {
                    updateLineItem(lineItem, { donation_id: value.id })
                  }}
                  options={items}
                  getOptionLabel={(donation) => `${donation.name} | ${donation.description} | ${parseFloat(donation.unit_cost).toFixed(2)} ${donation.currency}`}
                  getOptionValue={(donation) => donation.id}
                />
              </div>
            }
          </div>
          <div className="col-md-3" style={{ padding: "0px" }}>
            {(invoice.status == "active" || invoice.status == "overdue" || invoice.status == "sent" || invoice.status == "paid") &&
              <div className="form-group">
                <label>Receiver</label>
                <Select
                  className="form-control"
                  classNamePrefix="select-donation"
                  value={receiver}
                  onChange={(value) => {
                    prepData(value)
                    setUpdated(true)
                  }}
                  isDisabled
                  options={receivers}
                  getOptionLabel={(r) => `${r.name}`}
                  getOptionValue={(donation) => donation.name}
                />
              </div>
            }
            {(!invoice.status || invoice.status === "draft") &&
              <div className="form-group">
                <label>Receiver</label>
                <Select
                  className="form-control"
                  classNamePrefix="select-donation"
                  value={receiver}
                  onChange={(value) => {
                    prepData(value)
                    setUpdated(true)
                  }}
                  options={receivers}
                  getOptionLabel={(r) => `${r.name}`}
                  getOptionValue={(donation) => donation.name}
                />
              </div>
            }
          </div>
          <div className="col-md-1" style={{ padding: "0px" }}>
            {(invoice.status == "active" || invoice.status == "overdue" || invoice.status == "sent" || invoice.status == "paid") &&
              <div className="form-group">
                <label htmlFor="quantity">Quantity</label>
                <input
                  className="form-control"
                  placeholder="1.0"
                  min="1"
                  type="number"
                  step="0.01"
                  name="quantity"
                  id="quantity"
                  value={lineItem.quantity}
                  onChange={(e) => {
                    const val = e.target.value;
                    updateLineItem(lineItem, { quantity: val })
                  }}
                  disabled
                />
              </div>
            }
            {(!invoice.status || invoice.status === "draft") &&
              <div className="form-group">
                <label htmlFor="quantity">Quantity</label>
                <input
                  className="form-control"
                  placeholder="1.0"
                  type="number"
                  step="0.01"
                  min="1"
                  name="quantity"
                  id="quantity"
                  value={lineItem.quantity}
                  onChange={(e) => {
                    const val = e.target.value;
                    updateLineItem(lineItem, { quantity: val })
                  }}
                  onBlur={(e) => {
                    if (!e.target.value) updateLineItem(lineItem, {quantity: 1})
                  }}
                />
              </div>
            }
          </div>
          <div className="col-md-1" style={{ padding: "0px" }}>
            {(invoice.status == "active" || invoice.status == "overdue" || invoice.status == "sent" || invoice.status == "paid") &&
              <div className="form-group">
                <label htmlFor="tax">Tax</label>
                <input
                  className="form-control"
                  placeholder="0.00"
                  type="number"
                  min="1"
                  step="0.01"
                  name="tax"
                  id="tax"
                  value={lineItem.tax}
                  onChange={(e) => {
                    const val = e.target.value;
                    updateLineItem(lineItem, { tax: val })
                  }}
                  disabled
                />
              </div>
            }
            {(!invoice.status || invoice.status === "draft") &&
              <div className="form-group">
                <label htmlFor="tax">Tax</label>
                <input
                  className="form-control"
                  placeholder="0.00"
                  type="number"
                  min="1"
                  step="0.01"
                  name="tax"
                  id="tax"
                  value={lineItem.tax}
                  onChange={(e) => {
                    const val = e.target.value;
                    updateLineItem(lineItem, { tax: val })
                  }}
                  onBlur={(e) => {
                    if (!e.target.value) updateLineItem(lineItem, {tax: 0})
                  }}
                />
              </div>
            }
          </div>
          <div className="col-md-2" style={{ padding: "0px" }}>
            <div className="form-group">
              <label>Total</label>
              <div><strong>${parseFloat(totalLineItem).toFixed(2)} {donation.currency}</strong></div>
            </div>
          </div>

          {deleting &&
              <DeleteModal open={openModal} deleting={deleting} setDeleting={setDeleting} lineItem={lineItem} handleDelete={handleDelete} />
          }

          {!deleting &&
            <React.Fragment>
              {(invoice.status == "active" || invoice.status == "overdue" || invoice.status == "sent" || invoice.status == "paid") &&
                <div className="col-md-1 d-flex align-items-center" style={{ padding: "0px" }}>
                  <div className="form-group">
                    <label></label>
                    <button onClick={() => {
                        setDeleting(true),
                        setOpenModal(true)
                      }} disabled type="button" className="btn btn-icon btn-outline-danger">
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              }
              {(!invoice.status || invoice.status === "draft") &&
                <div className="col-md-1 d-flex align-items-center" style={{ padding: "0px" }}>
                  <div className="form-group">
                    <label></label>
                    <button onClick={() => {
                        setDeleting(true),
                        setOpenModal(true)
                      }} type="button" className="btn btn-icon btn-outline-danger">
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              }
            </React.Fragment>
          }
        </div>

    </React.Fragment>
  );
};

export default InvoiceLineItem;
